<form [formGroup]="formGroup">
  <mic-dropdown-search
    micDropdownAccessibility
    id="formDropdownInput"
    [label]="label"
    [nullLabel]="nullLabel"
    [placeholder]="placeholder"
    [emptyPlaceholder]="emptyPlaceholder"
    [searchPlaceholder]="searchPlaceholder"
    subscriptSizing="dynamic"
    [widthConfig]="{ width: '100%' }"
    [attribute]="attribute"
    [formControlName]="formControlName"
    [data]="data"
  />
</form>
